import React from 'react';
import moment from 'moment';
import { getActionIndicatorColor } from '../../../contractingUtils';
import { JiraFlatButton } from '../../../../tc-ui/small-buttons';

const tsStyle = {
  textAlign: 'left',
  fontSize: '10px',
  height: '16px',
  lineHeight: '16px',
  padding: '0 16px',
  textOverflow: 'ellipsis',
  overflowX: 'hidden',
  whiteSpace: 'nowrap',
};

const BasicBox = ({ content, ts, done, isSupplierAction, noArrow, tooltip, style, inactive, collapsed, onClick, hovering, buttonLabel, actorName }) => {
  const doneClass = isSupplierAction ? 'supplier-step-done' : 'buyer-step-done';
  const showBanner = !done && !inactive;

  const innerBoxStyle = { lineHeight: '48px', height: '48px', marginTop: collapsed ? '' : '4px', textAlign: 'left', width: '100%', paddingLeft: '16px' };
  return (
    <div
      style={{
        width: '0',
        height: collapsed ? '50px' : '88px',
        border: '1px solid #e0e0e0',
        borderBottom: '4px solid #e0e0e0',
        borderRight: 'none',
        cursor: onClick ? 'pointer' : '',
        ...style,
      }}
      onClick={onClick}
      className={`${noArrow ? '' : 'right-arrow-box'} ${done && !inactive ? doneClass : ''}`}
    >
      {
        showBanner ? (
          <div
            className="flag-across-progress-bar"
            style={{
              marginTop: collapsed ? '' : '4px',
              backgroundColor: getActionIndicatorColor({ viewingBy: 'Contractor', ratesReceived: !isSupplierAction }),
            }}
          >
            {isSupplierAction ? 'Waiting on Supplier' : 'Needs Your Attention'}
          </div>
        ) : <div style={{ height: '14px' }} />
      }
      <div
        className={tooltip ? 'hint--top' : ''}
        aria-label={tooltip}
        style={{
          ...innerBoxStyle,
          color: done && !inactive ? '' : '#b4b4b4',
        }}
      >
        {
          hovering && onClick ? <JiraFlatButton label={buttonLabel} style={{ border: '1px solid #e0e0e0' }} labelStyle={{ color: '#5E6C84', padding: '0 4px' }} />
            : <div style={{ padding: '0 5px' }}>{content}</div>
        }
      </div>
      <div
        style={{
          ...tsStyle,
          visibility: !collapsed && Boolean(ts) && !inactive ? 'visible' : 'hidden',
        }}
      >
        {moment(isNaN(ts) ? ts : ts * 1000).calendar(null, {
          sameDay: 'h:mm a',
          lastDay: '[Yesterday] h:mm a',
          lastWeek: '[Last] dddd',
          sameElse: 'DD MMM YYYY',
        })}{actorName ? ` by ${actorName}` : ''}
      </div>
    </div>
  );
};

export default BasicBox;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/progressIndicatorBar/basicBox.jsx